import axios from 'axios';
import { getApiBaseUrl } from '../config/apiBase';

const api = axios.create({
  baseURL: getApiBaseUrl(),
});

/** Token must be read per request — module load often runs before login, so a frozen header stays null. */
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('userToken');
  config.headers = config.headers || {};
  config.headers['x-access-token'] = token;
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  } else if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
});

export default api;
